import { render, staticRenderFns } from "./DynamicAttributesInputs.vue?vue&type=template&id=55e8d01a&"
import script from "./DynamicAttributesInputs.vue?vue&type=script&lang=ts&"
export * from "./DynamicAttributesInputs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports